import { Box, Icon } from '@fairfashion/design-system'

import * as Styles from './header-info-item.styles'
import { HeaderInfoItemProps } from './header-info-item.types'

export const HeaderInfoItem = ({
  icon,
  color,
  label,
  value,
}: HeaderInfoItemProps) => {
  return (
    <Box gap={2}>
      <Styles.IconContainer>
        <Icon name={icon} color={color} size={24} />
      </Styles.IconContainer>

      <Box direction="column">
        <Styles.Label>{label}</Styles.Label>
        <Styles.Value>{value || '-'}</Styles.Value>
      </Box>
    </Box>
  )
}
